export default "__VITE_ASSET__iM48dkSB__"